import { GridContainer, GridItem } from '../shared/ui-extension';
import { Divider, Link, Typography } from '@mui/material';
import { ItemImage } from '../shared/item-image';
import { printRoundedNumber } from '../../shared/utils';

export const MatchingItemCard = ({ item }) => {
  const { item_id, extended_desc, supplier_name, qty_avail, qty_on_hand } =
    item;

  return (
    <GridContainer alignItems='flex-start' title={supplier_name}>
      <GridItem xs={2}>
        <ItemImage itemId={item_id} scale={1.35} />
      </GridItem>
      <GridItem xs={10}>
        <GridContainer rowSpacing={0}>
          <GridItem xs={12}>
            <Link href={`/item?itemId=${item_id}`} target='_blank'>
              <Typography sx={{ fontWeight: 'bold' }}>{item_id}</Typography>
            </Link>
          </GridItem>
          {(extended_desc && (
            <GridItem xs={12}>
              <Typography sx={{ fontSize: '12px' }}>{extended_desc}</Typography>
            </GridItem>
          )) ||
            null}
          {(qty_on_hand && (
            <GridItem xs={6}>
              <Typography>QOH: {printRoundedNumber(qty_on_hand, 0)}</Typography>
            </GridItem>
          )) ||
            null}
          {(qty_avail && (
            <GridItem xs={6}>
              <Typography>Avail: {printRoundedNumber(qty_avail, 0)}</Typography>
            </GridItem>
          )) ||
            null}
        </GridContainer>
      </GridItem>
      <GridItem xs={12}>
        <Divider />
      </GridItem>
    </GridContainer>
  );
};
